import React from "react";
import Classnames from "classnames";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import Collapse from "rc-collapse";

const Accordion = ({ className, accordion = true, panelList = [] }) => {
  console.log("🚀 ~ file: Accordion.js ~ line 12 ~ panelList", panelList);
  return (
    <Collapse
      accordion={accordion}
      className={Classnames("accordion-container", className)}
      expandIcon={({ isActive }) =>
        isActive ? <KeyboardArrowUp /> : <KeyboardArrowDown />
      }
    >
      {panelList
        ?.filter((p) => !!p)
        .map((panel) => {
          if (panel?.isHidden) return null;
          return (
            <Collapse.Panel
              key={panel.header}
              header={panel.header}
              headerClass={Classnames(
                "accordion-header",
                panel.headerClassName
              )}
            >
              {panel.component}
            </Collapse.Panel>
          );
        })}
    </Collapse>
  );
};

export default Accordion;
